module.exports = __webpack_public_path__ + "img/RedteaMobile_ picture3 web.3edb6415.png";